import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/rockport")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Boat Covers, Awnings & Marine Canvas in Rockport, TX | Texas Made Shade",
      description: "Custom marine canvas, boat covers, T-tops, awnings and patio & pergola covers for Rockport & Aransas County. Built in Seguin, installed on the Texas Coast.",
      keywords: "pergola covers Rockport, pergola covers Texas, custom pergola covers Rockport, aluminum pergola covers Rockport",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Rockport, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Rockport and Aransas County.",
    }),
    scripts: cityHeadScripts("Rockport", "Aransas County"),
  }),
  component: () => <CityHomePage city="Rockport" region="Aransas County" />,
});
